export const TEAMMATE_SELECT_HINT = 'shift + ↑/↓ to select'
